import { Component } from '@theme/component';

class ProductFunnel extends Component {
  connectedCallback() {
    super.connectedCallback();
  }

  handlePhotoSelected(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.files?.length) return;

    const [file] = input.files;
    const preview = this.refs.previewImage;

    if (preview instanceof HTMLImageElement) {
      preview.src = URL.createObjectURL(file);
      preview.hidden = false;
    }

    if (this.refs.uploadPlaceholder instanceof HTMLElement) {
      this.refs.uploadPlaceholder.hidden = true;
    }
    // Button enable/loading state handled by funnel-personalization.js
  }
}

if (!customElements.get('product-funnel-component')) {
  customElements.define('product-funnel-component', ProductFunnel);
}
